import { onLink } from '../../handlers';

export const getIsUpdated = (props, sectionName) => {
  const stateProps = props.stateProps;
  const navSections = props.navSections;
  const resumeIndex = stateProps.sectionData.resumeIndex;
  let isUpdated = false;
  const section = stateProps.dataToSave.saved.resumes[resumeIndex][sectionName];
  if (typeof section !== 'undefined') {
    const criteria_raw = navSections[sectionName].criteria;
    if(criteria_raw !== '' ) {
      const criteria = criteria_raw.split(',');
      for(const criterion_raw of criteria) {
        const criterion = criterion_raw.split('!=');
        if (typeof section[0] !== 'undefined' && typeof section[0][criterion[0]] !== 'undefined') {
          const value = section[0][criterion[0]];
          if (value !== '' && value !== criterion[1]) {
            isUpdated = true;
          } else {
            isUpdated = false;
            break;
          }
        }
      }
    } else {
        isUpdated=true;
    }
  }
  return isUpdated;
};
export const getIsAllowed = (section, sectionName) => {
  let isAllowed = false;
  for (let allowedSection of Object.values(section)) {
    if (sectionName !== allowedSection) {
      continue;
    } else {
      isAllowed = true;
      break;
    }
  }
  return isAllowed;
};


export const toggleMenu = (formikProps, stateProps) => {
  if (stateProps.menuExpanded) {
    stateProps.setMenuExpanded(false);
    onLink(false,formikProps, stateProps, 'menu');
  } else {
    stateProps.setMenuExpanded(true);
    onLink(false,formikProps, stateProps, 'menu-ex');
  }
};